// This file can be moved to a more appropriate location later on 
var EntitlementPeriod = require('./EntitlementPeriod');

class EntitlementSummary{  
    constructor(entitlementArray = []){
        this.rawEntitlementArray = entitlementArray
        this.entitlementGroupMap = {

        }
    }

    isNull(){
        return !this.rawEntitlementArray || !this.currentPeriod || !this.currentPeriod.startDate
    }

    containsDate(date){
        return this.currentPeriod ? this.currentPeriod.containsBookingDate({date}) || this.nextPeriod.containsBookingDate({date}) : false;
    }

    filterByEntitlementGroups(entitlementGroupsOfServices){
        this.rawEntitlementArray = this.rawEntitlementArray.filter(entitlementDetail =>{
            return entitlementDetail.isFoundInEntitlementGroups(entitlementGroupsOfServices)
        })

        // Assign Entitlement Group Mapping
        entitlementGroupsOfServices.forEach(entitlementGroup =>{
            this.entitlementGroupMap[entitlementGroup.entitlement_setting_id] = entitlementGroup.api_value;
        })
    }
    calculateCurrentAndNextPeriod(dateNowString){
        var entitlementArray = this.rawEntitlementArray
        var currentPeriod = new EntitlementPeriod(),
        nextPeriod = new EntitlementPeriod();

        // Sort the entitlements by their start date
        entitlementArray = entitlementArray.sort((a, b)=>{
            return a.startDate.getTime() - b.startDate.getTime();
        })

        entitlementArray.forEach(entitlementDetails => {
            // Assign an ID using group name mapping
            for(var key in this.entitlementGroupMap){
                if(this.entitlementGroupMap[key].toLowerCase() == entitlementDetails.entitlementType.toLowerCase()){
                    entitlementDetails.entitlementGroupingId = key;
                }
            }
            
            // Assign a current period according to the most recent periods
            if(!currentPeriod.startDate && entitlementDetails.isEntitlementValid(dateNowString)){
                currentPeriod.startDate = entitlementDetails.startDate;
                currentPeriod.endDate = entitlementDetails.endDate;
            }
            if(currentPeriod.startDate // A current Period to anchor on exists
                &&  entitlementDetails.startDate.getTime() >= currentPeriod.endDate.getTime() // The start date of the period comes after the current period's end
                && (!nextPeriod.startDate || nextPeriod.startDate.getTime() > entitlementDetails.startDate.getTime()) // A nextPeriod doesn't exist or one that is earlier than the current is found
            ){
                nextPeriod.startDate = entitlementDetails.startDate;
                nextPeriod.endDate = entitlementDetails.endDate;
            }
        });

        // get remaining for each period
        let totalEntitlements = 0
        entitlementArray.forEach(entitlement =>{
            if(currentPeriod.startDate && currentPeriod.startDate.getTime() <= entitlement.startDate.getTime() && currentPeriod.endDate.getTime() >= entitlement.endDate.getTime()){
                if(!currentPeriod.entitlementsRemaining[entitlement.entitlementGroupingId]){
                    currentPeriod.entitlementsRemaining[entitlement.entitlementGroupingId] = 0;
                }
                currentPeriod.entitlementsRemaining[entitlement.entitlementGroupingId] += parseInt(entitlement.entitlementsRemaining);
                totalEntitlements += parseInt(entitlement.entitlementsRemaining)
                currentPeriod.entitlementDetails.push(entitlement);
            }
            else if(nextPeriod.startDate && nextPeriod.startDate.getTime() <= entitlement.startDate.getTime() && nextPeriod.endDate.getTime() >= entitlement.endDate.getTime()){
                if(!nextPeriod.entitlementsRemaining[entitlement.entitlementGroupingId]){
                    nextPeriod.entitlementsRemaining[entitlement.entitlementGroupingId] = 0;
                }
                nextPeriod.entitlementsRemaining[entitlement.entitlementGroupingId] += parseInt(entitlement.entitlementsRemaining);
                nextPeriod.entitlementDetails.push(entitlement);
            }
        })

        this.currentPeriod = currentPeriod;
        this.nextPeriod = nextPeriod
        this.totalEntitlements = totalEntitlements
    }

    calculateEffectiveEntitlements(availableBookingDatesOfAddress = []){
        var effectiveEntitlements = {
            current : {},
            next : {}
        };
        if(this.isNull()){
            this.effectiveEntitlements = effectiveEntitlements; // Default to false;
        }

        // Determine Current and Next Periods
        var currentPeriod = this.currentPeriod;
        var nextPeriod = this.nextPeriod;

        // Determine if there are bookings available to spend the entitlements
        var isCurrentAvailable = false;
        var isNextAvailable = false;

        availableBookingDatesOfAddress.forEach(bookingDate =>{
            if(bookingDate.availableBookings > 0){
                if(!isCurrentAvailable && currentPeriod.containsBookingDate(bookingDate)){
                    isCurrentAvailable = true;
                }
                else if(!isNextAvailable && nextPeriod.containsBookingDate(bookingDate)){
                    isNextAvailable = true;
                }
            }
        });

        
        // Add the entitlements accordingly
        if(isCurrentAvailable){
            for(var key in currentPeriod.entitlementsRemaining){
                if(!effectiveEntitlements[key])effectiveEntitlements[key] = 0;
                if(!effectiveEntitlements.current[key])effectiveEntitlements.current[key] = 0;
                effectiveEntitlements.current[key] += currentPeriod.entitlementsRemaining[key]
                effectiveEntitlements[key] += currentPeriod.entitlementsRemaining[key]
            }
        } else {
            // Handle NaN / Undefined Values
            for(var key in currentPeriod.entitlementsRemaining){
                // Set to 0 if undefined
                effectiveEntitlements[key] = 
                    (typeof effectiveEntitlements[key] === 'undefined') 
                    ? 0 : effectiveEntitlements[key];
                // Set to 0 if undefined
                effectiveEntitlements.current[key] = 
                    (typeof effectiveEntitlements.current[key] === 'undefined') 
                    ? 0 : effectiveEntitlements.current[key];
            }
        }
        
        if(isNextAvailable){
            for(var key in nextPeriod.entitlementsRemaining){
                if(!effectiveEntitlements.next[key])effectiveEntitlements.next[key] = 0;
                effectiveEntitlements.next[key] += nextPeriod.entitlementsRemaining[key]
                effectiveEntitlements[key] += nextPeriod.entitlementsRemaining[key]
            }
        } else {
            // Handle NaN / Undefined Values
            for(var key in nextPeriod.entitlementsRemaining){
                // Set to 0 if undefined
                effectiveEntitlements[key] = 
                    (typeof effectiveEntitlements[key] === 'undefined') 
                    ? 0 : effectiveEntitlements[key];
                // Set to 0 if undefined
                effectiveEntitlements.next[key] = 
                    (typeof effectiveEntitlements.next[key] === 'undefined') 
                    ? 0 : effectiveEntitlements.next[key];
            }
        }
        this.effectiveEntitlements = effectiveEntitlements;
    }

}

module.exports = EntitlementSummary;